import { io } from 'socket.io-client';

const SERVER_URL = process.env.REACT_APP_SERVER_URL || '';

export const connectToGameSocket = (room, client, displayName, profile = {}, spectate = false) => {
    const socket = io(SERVER_URL, {
        query: {
            action: 'connectToGame',
            spectate: spectate ? '1' : '0',
            room,
            client: profile.userId || client,
            displayName,
            userId: profile.userId || client,
            id: profile.id || profile.userId || client,
            uuid: profile.uuid || profile.userId || client,
            avatarUrl: profile.avatarUrl || '',
            frameUrl: profile.frameUrl || '',
            callerId: profile.callerId || '',
            gender: profile.gender || '',
            rating: profile.rating || 0,
            interests: JSON.stringify(profile.interests || []),
            numericId: profile.numericId || profile.id || '',
        }
    });
    socket.connect();
    return socket;
};

export const connectToServerSocket = (clientID) => {
    const socket = io(SERVER_URL, {
        query: {
            action: 'connectToServer',
            client: clientID,
        }
    });
    socket.connect();
    return socket;
};


export const disconnectFromSocket = (socket) => {
    socket.disconnect();
    return socket;
}
